import { styled, Typography } from '@mui/material';

export const TooltipText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.white,
}));

export const TooltipChildWrapper = styled('div')(() => ({
  display: 'inline-flex',
}));
